import { enableProdMode } from '@angular/core';
// The browser platform with a compiler
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { KeycloakAuthHttp } from '@elotech/angular-common';
// The app module
import { AppModule } from './app.module';
import { environment } from './environments/environment';
import { KeycloakAuthConfig } from './keycloak/keycloak-auth-config';
import './locale';
import { Cookie } from 'ng2-cookies/ng2-cookies';

if (environment.production) { enableProdMode(); }

new KeycloakAuthHttp(null, new KeycloakAuthConfig(), null).init({
  redirectUri: 'http://' + window.location.host + (window.location.host.endsWith('elotech.com.br') ? '/portal-servidor/home' : '/home'),
  onLoad: 'login-required'
}).then(() => {

  //Ajuste provisorio, ajustar no angular-common e remover esse código, angular-common esta gravando no cookie undefined.
  if (Cookie.get('DATA_OPERACAO') === 'undefined') {
    Cookie.set('DATA_OPERACAO', 'null', 1, '/', window.location.hostname);
  }

  // Compile and launch the module
  platformBrowserDynamic().bootstrapModule(AppModule);
}).catch(() => {
  window.location.reload();
});
